// extracted by mini-css-extract-plugin
module.exports = {"dialogBtn":"style-module__dialogBtn___tmN8C","dialogTitle":"style-module__dialogTitle___1IgdI"};